export default "__VITE_ASSET__BmRXi$nu__"